import { computed, type ComputedRef } from 'vue';

import { useUserStore } from '@/shared/pinia/modules/user';
import { generateContactUuid } from '@/shared/utils/emarsys';
import { hobbiiLocalStorage } from '@/shared/utils/web-storage';

// Written to localStorage at in-browser newsletter signup; read back here so a
// visitor who signed up in this browser but is not logged in stays attributable.
export const CONTACT_UUID_STORAGE_KEY = 'emarsysUUID';

/**
 * The customer key (contact_uuid) for attributing pattern downloads, when knowable:
 * a uuidv5 of the logged-in customer's email, else the value stashed at newsletter
 * signup, else null for an anonymous visitor. Optional by design — never blocks a
 * download.
 */
export function useContactUuid(): ComputedRef<string | null> {
  const userStore = useUserStore();

  return computed(() => {
    if (userStore.isLogged && userStore.customer?.email) {
      return generateContactUuid(userStore.customer.email);
    }

    return hobbiiLocalStorage.getItem(CONTACT_UUID_STORAGE_KEY);
  });
}
